<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import RoleTabs from './RoleTabs.vue';
    import QueryKey from '@/enums/QueryKey';

    const form = useForm({
        name: '',
        display_name: '',
        description: '',
        is_client: 0,
        permission_ids: [],
        role_company_ids: [],
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.roles.store')"
        :query-key="[QueryKey.ROLES]"
        title="roles.create"
        button-text="roles.create"
        modal-size="sm:max-w-3xl"
    >
        <RoleTabs :form="form" />
    </DialogForm>
</template>
